let request = require('superagent');
import AppData from './AppData';

let errResponseHandler = (res) => {
  if (res.statusCode >= 400) {
    let responseObject = getResponseErrorPayload(res);
    switch (res.statusCode) {
      case 500:
        {
          AppData.notifyListeners('REQUEST_SERVER_ERROR', responseObject);
        }
        break;
      case 502:
        {
          AppData.notifyListeners('REQUEST_GATEWAY_ERROR', {
            message: 'Application gateway server is offline. Try again later.',
            debug: {},
          });
        }
        break;
      case 400:
        {
          AppData.notifyListeners('REQUEST_SUBMISSION ERROR', responseObject);
        }
        break;
      case 401:
        {
          AppData.notifyListeners(
            'REQUEST_AUTHORIZATION_DENIED',
            responseObject,
          );
        }
        break;
      case 403:
        {
          AppData.notifyListeners(
            'REQUEST_AUTHORIZATION_DENIED',
            responseObject,
          );
        }
        break;
      case 404:
        {
          AppData.notifyListeners('REQUEST_RESOURCE_MISSING', responseObject);
        }
        break;
    }
    return false;
  }
  return true;
};

export function get() {
  return request
    .get(...arguments)
    .set('Authorization', 'Bearer ' + AppData.get('authToken'))
    .ok(errResponseHandler);
}
export function post() {
  return request
    .post(...arguments)
    .set('Authorization', 'Bearer ' + AppData.get('authToken'))
    .ok(errResponseHandler);
}
export function put() {
  return request
    .put(...arguments)
    .set('Authorization', 'Bearer ' + AppData.get('authToken'))
    .ok(errResponseHandler);
}
export function del() {
  return request
    .delete(...arguments)
    .set('Authorization', 'Bearer ' + AppData.get('authToken'))
    .ok(errResponseHandler);
}
export function patch() {
  return request
    .patch(...arguments)
    .set('Authorization', 'Bearer ' + AppData.get('authToken'))
    .ok(errResponseHandler);
}
export function getResponseErrorPayload(res) {
  let error = res.error;
  let stack = error?.stack;

  let body = res?.body;
  let debug = body?.debug;
  let debugObject;
  if (debug) {
    let bodyMessage = `${debug.name}${
      body?.message ? ': ' + body.message : ''
    }`;
    debugObject = handleSequelizeErrors(body);
    debugObject.message = bodyMessage;
  } else {
    debugObject = res;
  }

  let message = body?.message;
  let url = res.req?.url || error?.url;
  if (url) {
    // const regex = /^(.+(?:api|reporter)\/[^ ]*\?)(.*) \((.*)\)/;
    const regex = /.+?(?=\?)/;
    let regexedURL = regex.exec(url);
    if (regexedURL?.length) {
      url = `${regexedURL[0]}... `;
    }
  }
  url = `${res.req?.method ? res.req.method + ' ' : ''}${url}`;

  let text = debug?.text || res.text;
  let htmlText = {};
  if (text?.includes('<!DOCTYPE html>')) {
    const titleRegex = /<title>([\s\S]*?)<\/title>/i;
    const bodyRegex = /<body[^>]*>([\s\S]*?)<\/body>/i;

    const titleMatch = text.match(titleRegex);
    const bodyMatch = text.match(bodyRegex);

    htmlText.title = titleMatch[0];
    htmlText.body = bodyMatch[0];
    text = '';
  }

  return { message, stack, debugObject, text: res.text, url, htmlText };
}
export function handleSequelizeErrors(responseBody) {
  let { debug } = responseBody;
  if (debug?.name && debug.name.toLowerCase().includes('sequelize')) {
    if (debug.errors) {
      const errors = debug.errors.map((e) => {
        return e.message;
      });

      return { ...responseBody, errors };
    }
    if (debug.original) {
      return {
        ...responseBody,
        errors: [debug.original.message || debug.original.detail],
      };
    }
  }
  return responseBody;
}
